export default __webpack_public_path__ + "static/screenshot-mybiz-3-d5747228d92b06ec38b7593ddbbaadf2.jpg";